/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviationRateRequest } from '../models/DeviationRateRequest';
import type { DeviationRateResponse } from '../models/DeviationRateResponse';
import type { SellingPriceRequest } from '../models/SellingPriceRequest';
import type { SellingPriceResponse } from '../models/SellingPriceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FormulaControllerService {
    /**
     * @param discountedRequestPrice
     * @param discountedCategory
     * @returns number OK
     * @throws ApiError
     */
    public static getSellingPriceFromDiscountedSellingPrice1(
        discountedRequestPrice: number,
        discountedCategory: string,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/selling-price',
            query: {
                'discountedRequestPrice': discountedRequestPrice,
                'discountedCategory': discountedCategory,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SellingPriceResponse OK
     * @throws ApiError
     */
    public static getSellingPriceFromDiscountedSellingPrice(
        requestBody: SellingPriceRequest,
    ): CancelablePromise<SellingPriceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/selling-price',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns DeviationRateResponse OK
     * @throws ApiError
     */
    public static getDeviationRates(
        requestBody: DeviationRateRequest,
    ): CancelablePromise<DeviationRateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/deviation-rate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestPrice
     * @param discountedCategory
     * @returns number OK
     * @throws ApiError
     */
    public static getDiscountedSellingPriceFromSellingPrice(
        requestPrice: number,
        discountedCategory: string,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/discounted-selling-price',
            query: {
                'requestPrice': requestPrice,
                'discountedCategory': discountedCategory,
            },
        });
    }
}
